/**
 * Fixed plot height for GHG Inventory page figures (sector, consumption, comparison, per capita).
 * Slightly below a typical full pie legend layout, above prior line/stacked/per-capita defaults.
 */
export const GHG_INVENTORY_CHART_HEIGHT_PX = 408;
